module.exports = __webpack_public_path__ + "img/asterika-rectangle.030b7491.jpg";